import React from 'react';
import './cta.css';

const CTA = () => (
    <div className="sam__cta" dir='rtl'>
        <div className="sam__cta-content">
            <p>آکادمی برنامه نویسی رایا</p>
            <h3>به آکادمی رایا بپیوندید و از آموزش ها و کلاس های برنامه نویسی رایا استفاده کنید.</h3>
        </div>
        <div className="sam__cta-btn">
            <button type="button"><a href="https://instagram.com/raya._.academy">ما را دنبال کنید</a></button>
        </div>
    </div>
);

export default CTA;
